var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('h3',[_vm._v("Panel de Control")]),_c('v-divider'),_c('InstanceByUserFilterViewComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }